import { governmentServices } from '../../../mocks/government-services';

export default function GovernmentServices() {
  const categories = ['All', 'City Services', 'Public Safety', 'Utilities', 'Recreation', 'Business'];
  
  return (
    <section id="government-services" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Government <span className="text-teal-600">Services</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Access official city resources, public services, and government information
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {governmentServices.map((service) => (
            <a
              key={service.id}
              href={service.url}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-xl p-6 shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-teal-200 group cursor-pointer"
            >
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-50 rounded-lg group-hover:bg-teal-100 transition-colors">
                  <i className={`${service.icon} text-2xl text-teal-600`}></i>
                </div>
                <div className="flex-1">
                  <div className="flex items-start justify-between mb-2">
                    <h3 className="text-lg font-semibold text-gray-900 group-hover:text-teal-600 transition-colors">
                      {service.title}
                    </h3>
                    <i className="ri-external-link-line text-gray-400 group-hover:text-teal-600 transition-colors"></i>
                  </div>
                  <p className="text-sm text-gray-600 mb-3">
                    {service.description}
                  </p>
                  <span className="inline-block px-3 py-1 bg-gray-100 text-gray-700 text-xs font-medium rounded-full">
                    {service.category}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-teal-500 to-teal-600 rounded-2xl p-8 text-center text-white">
          <div className="max-w-3xl mx-auto">
            <i className="ri-customer-service-2-line text-5xl mb-4"></i>
            <h3 className="text-2xl font-bold mb-3">Need Assistance?</h3>
            <p className="text-teal-50 mb-6 text-lg">
              Contact Roseville City Hall for general inquiries and support
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a 
                href="tel:916-774-5000" 
                className="bg-white text-teal-600 px-8 py-3 rounded-full font-semibold hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center space-x-2"
              >
                <i className="ri-phone-line"></i>
                <span>(916) 774-5000</span>
              </a>
              <a 
                href="https://www.roseville.ca.us/government/city_hall" 
                target="_blank"
                rel="noopener noreferrer"
                className="bg-teal-700 text-white px-8 py-3 rounded-full font-semibold hover:bg-teal-800 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center space-x-2"
              >
                <i className="ri-map-pin-line"></i>
                <span>Visit City Hall</span>
              </a>
            </div>
            <p className="text-teal-100 text-sm mt-4">
              5098 Foothills Blvd, Suite 3-402, Roseville, CA 95747
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
